import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'safeHTML',
  standalone: false,
})
export class SafeHtmlFilter implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string): SafeHtml {
    // User-authored content flows through this pipe (comments, wiki, spark) —
    // strip script/event-handler payloads but keep tiptap markup and inline styles,
    // which Angular's own sanitizer would drop.
    return this.sanitized.bypassSecurityTrustHtml(DOMPurify.sanitize(value ?? ''));
  }
}

@Pipe({
    name: 'safeURL',
    standalone: false
})
export class SafeURLPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url: string): any {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}

@Pipe({
    name: 'safeResourceURL',
    standalone: false
})
export class SafeResourceURLPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url: string): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
